export default {
      id: "icon-facebook-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }